import script from "./TrainingDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&setup=true&lang=js"

import "./TrainingDetail.vue?vue&type=style&index=0&id=f237cb64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f237cb64"]])

export default __exports__